export default "__VITE_ASSET__QJ3zuayl__"